if (!customElements.get('product-info-tabs')) {
  class ProductInfoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.handleClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.activate(tab);
      };
      this.handleKeydown = (event) => {
        const current = event.target.closest('[role="tab"]');
        if (!current || !this.contains(current)) return;
        const index = this.tabs.indexOf(current);
        const step = this.dir === 'rtl' ? -1 : 1;
        let next = index;
        if (event.key === 'ArrowRight') next = (index + step + this.tabs.length) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - step + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[next], true);
      };
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    activate(activeTab, focus = false) {
      this.tabs.forEach((tab) => {
        const selected = tab === activeTab;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        const panel = this.querySelector(`[id="${tab.getAttribute('aria-controls')}"]`);
        if (panel) panel.hidden = !selected;
      });
      const nav = activeTab.parentElement;
      if (nav) {
        const tabRect = activeTab.getBoundingClientRect();
        const navRect = nav.getBoundingClientRect();
        if (tabRect.left < navRect.left) nav.scrollLeft += tabRect.left - navRect.left;
        else if (tabRect.right > navRect.right) nav.scrollLeft += tabRect.right - navRect.right;
      }
      if (focus) activeTab.focus();
    }
  }
  customElements.define('product-info-tabs', ProductInfoTabs);
}
